import RangePicker from './RangePicker.vue';

export default RangePicker;
